import type WorkflowTriggerDefinitionModel from '@src/service/model/workflow/WorkflowTriggerDefinitionModel'

import Repository from './base'

export const WORKFLOW_TRIGGER_DEFINITION_TABLE_NAME = 'workflowTriggerDefinition'
export class WorkflowTriggerDefinitionRepository extends Repository<WorkflowTriggerDefinitionModel> {}
